export default "__VITE_ASSET__CLvls0lI__"